import angular from 'angular';

angular.module('cloudX').directive('cxConfigRelevancy', [
  function() {
    return {
      restrict: 'E',
      template: require('./configRelevancy.html'),
      scope: {
        nullValue: '=',
        disabled: '=ngDisabled',
      },
      require: ['ngModel', 'cxConfigRelevancy'],
      link: function(scope, el, attrs, ctrl) {
        if (!ctrl || ctrl.length !== 2) return;
        ctrl[1].init(ctrl[0]);
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.collapsed = true;
          $scope.crmTypes = [];
          $scope.allChecked = [false, false];
          // Other = 0,
          // Prospect = 2,
          // Customer = 3
          // OwnCompany = 4
          $scope.crmTypes = [0, 2, 3, 4];

          $scope.transformBack = function() {
            var rel = $scope.relevancy;
            if (!rel) return;
            var all = true;
            var none = true;
            var output = [];

            for (var j = 0; j <= 2; j++) {
              var typeOutput = [];
              var typeAll = true;
              var typeNone = true;
              for (var i = 0; i < $scope.crmTypes.length; i++) {
                if (rel[j][$scope.crmTypes[i]]) {
                  typeOutput.push($scope.crmTypes[i]);
                  typeNone = false;
                  none = false;
                } else typeAll = false;
              }
              if (typeAll) typeOutput = null;
              else all = false;
              if (!typeNone)
                output.push({
                  relationType: j,
                  crmTypes: typeOutput,
                });
            }
            if (all) output = $scope.nullValue ? null : [];
            if (none) output = !$scope.nullValue ? null : [];
            $scope.setViewValue(output);
          };

          $scope.toggleChecked = function(type) {
            if ($scope.disabled) return;
            $scope.allChecked[type] = !$scope.allChecked[type];
            for (var i = 0; i < $scope.crmTypes.length; i++) {
              $scope.relevancy[type][$scope.crmTypes[i]] = $scope.allChecked[type];
            }
            $scope.transformBack();
          };

          this.init = function(ngModel) {
            // when angular detects a change to the model,
            // we update our inner value
            ngModel.$render = function() {
              $scope.relevancy = [{}, {}, {}];
              for (var i = 0; i < $scope.crmTypes.length; i++) {
                var crm = $scope.crmTypes[i];
                var data = ngModel.$viewValue;
                if (data) {
                  if (data.length > 0) {
                    for (var j = 0; j < data.length; j++) {
                      var relType = data[j].relationType;
                      var maxRelType = typeof relType === 'undefined' ? 2 : relType;
                      relType = relType || 0;
                      for (var r = relType; r <= maxRelType; r++) {
                        if (data[j].crmTypes) {
                          $scope.relevancy[r][crm] = data[j].crmTypes.indexOf(crm) >= 0;
                        } else {
                          $scope.relevancy[r][crm] = true;
                        }
                      }
                    }
                  } else {
                    //Empty array
                    $scope.relevancy[0][crm] = !$scope.nullValue;
                    $scope.relevancy[1][crm] = !$scope.nullValue;
                    $scope.relevancy[2][crm] = !$scope.nullValue;
                  }
                } else {
                  $scope.relevancy[0][crm] = $scope.nullValue;
                  $scope.relevancy[1][crm] = $scope.nullValue;
                  $scope.relevancy[2][crm] = $scope.nullValue;
                }
              }
            };
            $scope.setViewValue = function(value) {
              ngModel.$setViewValue(value);
            };
          };
        },
      ],
    };
  },
]);
